import TileWrapper from '../TileWrapper'

import { useTile } from '../../context'

const CustomTextTile = () => {
  const { tile } = useTile()

  return (
    <TileWrapper>
      <p className='whitespace-pre-wrap break-words'>{tile.config?.text}</p>
    </TileWrapper>
  )
}

export default CustomTextTile
